import React, { useEffect, useRef } from "react";
import { Button, Card, Tabs, Tooltip } from "antd";
import WarehouseDetailForm from "./WarehouseForm";
import AreaList from "./AreaList";
import PositionList from "./PositionList";
import ShelveList from "./ShelveList";
import AreaDrawer from "./AreaDrawer";
import ShelveDrawer from "./ShelveDrawer";
import PositionDrawer from "./PositionDrawer";
import { ProfileTwoTone } from "@ant-design/icons";
import { CM_ACTION_TYPE, ENV } from "../../../utils/constants";
import { useModelDispatchers, useModel } from "../../../models";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const { TabPane } = Tabs;


export default function () {
    const { closeNav } = useModelDispatchers("nav");
    const [{ selectedWarehouse, tabsKey }, { setTabsKey, loadShelve, loadArea, loadPosition }] = useModel("warehouse");
    const [{ userInfo }] = useModel("global");

    useEffect(() => {
        setTabsKey(1)
        loadArea({ showMsg: false, data: { warehouseId: selectedWarehouse ? selectedWarehouse.id : '', orgId: userInfo.orgId, pageSize: 100, pageNum: 1 } });
        loadShelve({ showMsg: false, data: { warehouseId: selectedWarehouse ? selectedWarehouse.id : '', orgId: userInfo.orgId, pageSize: 15, pageNum: 1 } });
        loadPosition({ showMsg: false, data: { warehouseId: selectedWarehouse ? selectedWarehouse.id : '', orgId: userInfo.orgId, pageSize: 15, pageNum: 1 } });

    }, []);
    const cRef = useRef();
    const save = () => {
        // changeVal就是子组件暴露给父组件的方法
        let ret = cRef.current.save();
    }
    const Title = () => {
        const onSave = () => {
            cRef.current.update();
        }
        const onReset = () => {
            cRef.current.reset();
        }
        const onClose = () => {
            closeNav();
        }

        return (
            <div style={{ display: "flex" }}>
                <h3 style={{ flex: "1" }}>
                    <ProfileTwoTone />
                    <span className="margin-left-8">仓库详情</span>
                </h3>
                <div style={{ width: "500px", textAlign: "right" }}>
                    <YhAuth resCode={ResourceAuthEnum.DATA_W_ED_SAVE}>
                        <Button type="primary" onClick={onSave}>保存</Button>
                    </YhAuth>
                    <Button className="margin-left-8" onClick={onReset}>重置</Button>
                    <Button className="margin-left-8" onClick={onClose}>关闭</Button>
                </div>
            </div>
        )
    }
    const TabTitle = () => {
        return (

            <Tooltip title="温馨提示：查看货架信息前请先选择仓库">
                <p style={{ position: "relative", top: "7px" }}>货架信息</p>
            </Tooltip>
        )
    }
    const TabTitle2 = () => {
        return (

            <Tooltip title="温馨提示：查看货位信息前请先选择货架">
                <p style={{ position: "relative", top: "7px" }}>货位信息</p>
            </Tooltip>
        )
    }
    const _onChange = (activeKey) => {
        setTabsKey(activeKey)
    }
    return (
        <>
            <Card
                bordered={true}
                title={<Title />}
                className="margin-top-8"
            >
                <WarehouseDetailForm cRef={cRef} actionType={CM_ACTION_TYPE.EDIT} />
            </Card>
            <Card
                bordered={true}
                className="margin-top-8"
            >
                <Tabs tabPosition="top" onChange={_onChange}>
                    <TabPane tab="区域信息" key="1">
                        <AreaList />
                    </TabPane>
                    <TabPane tab={<TabTitle />} key="2">
                        <ShelveList />
                    </TabPane>

                    <TabPane tab={<TabTitle2 />} key="3">
                        <PositionList />
                    </TabPane>
                </Tabs>
            </Card>
            <AreaDrawer />
            <ShelveDrawer />
            <PositionDrawer />
        </>
    )

};